<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
              title="Work Orders"
              icon="fas fa-list">
          </card-section-header>
          <!-- Filters -->
          <div class="form-row">
            <div class="filter-flex-row">
              <work-order-search-field></work-order-search-field>
              <div>
                <label>Asset</label>
                <text-filter-box
                  placeholder="Filter by asset name..."
                  (onFilterTextChanged)="onAssetFilterChanged($event)">
                </text-filter-box>
              </div>
              <filter-toggle-group
                label="Options"
                [options]="optionButtons"
                [value]="selectedOption"
                (valueChange)="onOptionChanged($event)">
              </filter-toggle-group>
              <filter-toggle-group
                label="Status"
                [options]="statusButtons"
                [value]="selectedState"
                (valueChange)="onStateChanged($event)">
              </filter-toggle-group>
            </div>
          </div>
          <div class="multiple-select_btn">
            <table-action-bar (toggleColumns)="columnOptionsSidebarVisible = true">
              <button *ngIf="!isControlAdmin" type="button" class="btn btn-link btn-danger btn-sm ml-3" [disabled]="!updateCloseButtonState()"
                (click)="closeSelectedWorkOrders()">
                <span><i class="fa fa-close" aria-hidden="true"></i></span> Close selected
              </button>
            </table-action-bar>
          </div>
          <!-- Table of results -->
          <div class="row">
            <div class="col-md-12">
              <p-table
                  [autoLayout]="true"
                  [value]="loading ? skeletonRows : workOrders"
                  selectionMode="single"
                  (onRowSelect)="onRowSelect($event)"
                  (onSort)="customSort($event)"
                  [sortField]="defaultSortField"
                  [sortOrder]="defaultSortOrder"
                  [lazy]="true"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>
                        <input *ngIf="!isControlAdmin" type="checkbox"
                          [(ngModel)]="selectedAllWorkOrders"
                          [disabled]="loading || refreshing"
                          (change)="selectAll($event)"/>
                    </th>
                    <th *ngIf="tableOptions.visibleColumns.includes('Asset')" [pSortableColumn]="'asset.name'">
                      <div>Asset
                        <p-sortIcon [field]="'asset.name'"></p-sortIcon>
                      </div>
                      <div class="small-data" *ngIf="tableOptions.joinAssetAndSite">
                        Site<span *ngIf="!this.isSiteOwner">/ Site Owner</span>
                      </div>
                    </th>
                    <th>Description</th>
                    <th *ngIf="tableOptions.visibleColumns.includes('Created By')" [pSortableColumn]="'createdBy'">Created By
                      <p-sortIcon [field]="'createdBy'"></p-sortIcon>
                    </th>
                    <th *ngIf="tableOptions.visibleColumns.includes('Created Date')" [pSortableColumn]="'createdDate'">Created Date
                      <p-sortIcon [field]="'createdDate'"></p-sortIcon>
                    </th>
                    <th *ngIf="tableOptions.visibleColumns.includes('Last Updated')" [pSortableColumn]="'lastModifiedDate'">Last Updated
                      <p-sortIcon [field]="'lastModifiedDate'"></p-sortIcon>
                    </th>
                    <th *ngIf="tableOptions.visibleColumns.includes('Status')" [pSortableColumn]="'status'">Status
                      <p-sortIcon [field]="'status'"></p-sortIcon>
                    </th>
                    <th *ngIf="showRequestedByColumn">Requested By</th>
                    <th *ngIf="allowAssetScheduling && tableOptions.visibleColumns.includes('Exempt From Scheduling')" class="text-center">Exempt From Scheduling</th>
                    <th *ngIf="tableOptions.visibleColumns.includes('Competency')">Competency</th>
                    <th *ngIf="!tableOptions.joinAssetAndSite && tableOptions.visibleColumns.includes('Site')" [pSortableColumn]="'asset.site.name'">Site
                      <p-sortIcon [field]="'asset.site.name'"></p-sortIcon>
                    </th>
                    <th *ngIf="!tableOptions.joinAssetAndSite && tableOptions.visibleColumns.includes('Site Owner') && !this.isSiteOwner" [pSortableColumn]="'asset.site.siteOwnerUser.skylarkUser.user.lastName'">Site Owner
                      <p-sortIcon [field]="'asset.site.siteOwnerUser.skylarkUser.user.lastName'"></p-sortIcon>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-workOrder>
                  <tr *ngIf="loading; else showRows">
                    <td [attr.colspan]="20">
                      <skeleton-loading-row></skeleton-loading-row>
                    </td>
                  </tr>
                  <ng-template #showRows>
                    <tr [pSelectableRow]="workOrder">
                      <td class="table-cell-centered" (click)="$event.stopPropagation()">
                        <div *ngIf="!isControlAdmin && workOrder.closable">
                          <input type="checkbox"
                            [(ngModel)]="workOrder.selected"
                            [disabled]="refreshing"
                            (change)="syncSelectAllBoxState()"/>
                        </div>
                      </td>
                      <td *ngIf="tableOptions.visibleColumns.includes('Asset')">
                          {{ workOrder.asset.name }}
                        <div class="small-data" *ngIf="tableOptions.joinAssetAndSite">
                          {{ workOrder.asset.site.name }}
                          <span *ngIf="!this.isSiteOwner">/ {{ workOrder.asset.site.siteOwner.firstName }} {{ workOrder.asset.site.siteOwner.lastName }}</span>
                        </div>
                      </td>
                      <td>
                        <div>
                          {{ workOrder.description }}
                        </div>
                        <div class="small-data">
                          <ng-container *ngIf="workOrder.externalWorkOrderId; else internalWorkOrderId">
                            EXT {{ workOrder.externalWorkOrderId }} | WRK {{ workOrder.id }}
                          </ng-container>
                          <ng-template #internalWorkOrderId>
                            WRK {{ workOrder.id }}
                          </ng-template>
                        </div>
                      </td>
                      <td *ngIf="tableOptions.visibleColumns.includes('Created By')">
                        {{ workOrder.createdBy }}
                      </td>
                      <td *ngIf="tableOptions.visibleColumns.includes('Created Date')">
                        <date-friendly [value]="workOrder.createdDate"></date-friendly>
                      </td>
                      <td *ngIf="tableOptions.visibleColumns.includes('Last Updated')">
                        <date-friendly [value]="workOrder.lastModifiedDate"></date-friendly>
                      </td>
                      <td *ngIf="tableOptions.visibleColumns.includes('Status')">
                        <work-order-state-badge [workOrder]="workOrder"></work-order-state-badge>
                      </td>
                      <td *ngIf="showRequestedByColumn">
                        <span *ngIf="workOrder.showRequestedBy">{{ workOrder.requestedByDisplay }}</span>
                      </td>
                      <td *ngIf="allowAssetScheduling && tableOptions.visibleColumns.includes('Exempt From Scheduling')" class="table-cell-centered">
                        <span *ngIf="workOrder.exemptFromAssetScheduling"><i class="fas fa-check-circle success"></i></span>
                        <span *ngIf="!workOrder.exemptFromAssetScheduling"><i class="fas fa-times-circle danger"></i></span>
                      </td>
                      <td *ngIf="tableOptions.visibleColumns.includes('Competency')">
                        <div class="competency-overview-cell">
                          <ng-container *ngIf="workOrder.detailedCompetencies === undefined; else competencyDataReady">
                            <div class="skeleton competency-count-skeleton"></div>
                            <div class="skeleton competency-status-skeleton"></div>
                          </ng-container>
                          <ng-template #competencyDataReady>
                            <ng-container *ngIf="workOrder.detailedCompetencies && workOrder.detailedCompetencies.length > 0">
                              <div *ngFor="let competency of workOrder.detailedCompetencies" class="competency-overview-item">
                                <span class="competency-overview-badge" [attr.style]="'background-color: ' + (competency.name | competencyBadgeColor) | safestyle">
                                  {{ competency.name }}
                                </span>
                                <span class="competency-overview-details" *ngIf="competency.oem">
                                  {{ competency.oem }}
                                  <span *ngIf="competency.model"> | {{ competency.model }}</span>
                                  <span *ngIf="competency.rating"> | {{ competency.rating }}</span>
                                  |
                                </span>
                              </div>
                            </ng-container>
                          </ng-template>
                        </div>
                      </td>
                      <td *ngIf="!tableOptions.joinAssetAndSite && tableOptions.visibleColumns.includes('Site')">
                        {{ workOrder.asset.site.name }}
                      </td>
                      <td *ngIf="!tableOptions.joinAssetAndSite && tableOptions.visibleColumns.includes('Site Owner') && !this.isSiteOwner">
                        {{ workOrder.asset.site.siteOwner.firstName }} {{ workOrder.asset.site.siteOwner.lastName }}
                      </td>
                      <td (click)="$event.stopPropagation()">
                        <ng-container *ngIf="!isControlAdmin && workOrder.approvalStatus === 'PENDING'; else checkClose">
                          <button type="button" class="btn btn-warning btn-round btn-sm multiple-select_btn__text"
                            [disabled]="refreshing"
                            (click)="rejectWorkOrder(workOrder)">reject</button>
                        </ng-container>

                        <ng-template #checkClose>
                          <ng-container *ngIf="!isControlAdmin && workOrder.closable">
                            <button type="button" class="btn btn-danger btn-round btn-sm multiple-select_btn__text"
                              [disabled]="refreshing || workOrder.selected"
                              (click)="closeSingleWorkOrder(workOrder.id)">close</button>
                          </ng-container>
                        </ng-template>
                      </td>
                    </tr>
                  </ng-template>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr *ngIf="loadError && !workOrders.length">
                    <td [attr.colspan]="20">Unable to load work orders</td>
                  </tr>
                  <tr *ngIf="!loadError && hasLoadedWorkOrders">
                    <td [attr.colspan]="20">No work orders found</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator
            #paginator
            [rows]="pagination.size"
            [totalRecords]="pagination.totalRecords"
            [rowsPerPageOptions]="pageSizes"
            (onPageChange)="paginate($event)">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- column options sidebar -->
<p-sidebar [(visible)]="columnOptionsSidebarVisible" position="right" [baseZIndex]="1000000">
  <h6 class="text-primary my-4">Column Options</h6>
  <label>Show:</label>
  <ng-container *ngFor="let col of togglableColumns">
    <div class="form-group">
      <p-checkbox name="togglableColumns" [value]="col.displayName" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="col.displayName"></p-checkbox>
    </div>
  </ng-container>
  <div class="form-group" *ngIf="!tableOptions.joinAssetAndSite">
    <p-checkbox name="togglableColumns" [value]="'Site'" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="'Site'"></p-checkbox>
  </div>
  <div class="form-group" *ngIf="!tableOptions.joinAssetAndSite && !this.isSiteOwner">
    <p-checkbox name="togglableColumns" [value]="'Site Owner'" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="'Site Owner'"></p-checkbox>
  </div>
  <br />
  <div class="form-group">
    <div *ngIf="isSiteOwner"><label>Combine Asset and Site</label></div>
    <div *ngIf="!isSiteOwner"><label>Combine Asset and Site / Site Owner</label></div>
    <p-inputSwitch [(ngModel)]="tableOptions.joinAssetAndSite" (ngModelChange)="saveTableOptions()"></p-inputSwitch>
  </div>
  <button (click)="resetColumnOptions()" class="mt-4 btn btn-round btn-default btn-simple btn-block">reset to default</button>
</p-sidebar>
